import { PropsWithChildren } from "react";
import { useUserContext } from "../../../context/user.context";
import { Permission } from "../../../models/group.model";
import PageLoader from "../../components/PageLoader/PageLoader";
import Forbidden from "../pages/Forbidden/Forbidden";

// Gates a screen behind a specific permission, independent of org/super admin status - the
// route-level backstop so navigating directly to a URL (bypassing the sidebar's own permission
// check) still can't reach the page. Mirrors RequireOrgAdmin/RequireSuperAdmin's loading pattern.
function RequirePermission({ permission, children }: PropsWithChildren<{ permission: Permission }>) {
  const { loading, hasPermission } = useUserContext();

  if (loading) {
    return <PageLoader />;
  }

  if (!hasPermission(permission)) {
    return <Forbidden />;
  }

  return <>{children}</>;
}

export default RequirePermission;
